import { useEffect, useRef, useState } from "react";

import Body from "../Navigation/Body";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputField from "./InputField";
import { useApi } from "../../contexts/ApiProvider";
import { useFlash } from "../../contexts/FlashProvider";
import { Link, useNavigate } from "react-router-dom";
import FlashMessage from "../Navigation/FlashMessage"; 
import './loginpage.css'; 

const INVITE_CODE = "ipcstudy2026";

export default function RegistrationPage() {
  const [formErrors, setFormErrors] = useState({});

  const usernameField = useRef();
  const emailField = useRef();
  const inviteCodeField = useRef();
  const passwordField = useRef();
  const password2Field = useRef();

  const { flash } = useFlash();

  useEffect(() => {
    usernameField.current.focus();
  }, []);

  const navigate = useNavigate();
  const api = useApi();

  const onSubmit = async (event) => {
    event.preventDefault();

    const errors = {};
    if (inviteCodeField.current.value.trim() !== INVITE_CODE) {
      errors.inviteCode = "Invite code is not valid.";
    }
    if (passwordField.current.value !== password2Field.current.value) {
      errors.password2 = "Passwords don't match";
    }
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    const data = await api.post("/users", {
      username: usernameField.current.value,
      email: emailField.current.value,
      password: passwordField.current.value,
      invite_code: inviteCodeField.current.value.trim(),
      is_admin: 0,
      progress: {},
    });

    if (!data.ok) {
      setFormErrors(data.body.errors.json);
      flash("Registration failed. Please check the form for errors.", "danger");
    } else {
      setFormErrors({});
      flash("You have successfully registered. Please log in.", "primary");
      navigate("/login");
    }
  };

  return (
    <Body>
      <div className="login-container registration-container">
        <FlashMessage />
        <h1 className="welcome-message">Register New User</h1>
        <p className="registration-subtitle">
          Create an account to access the IPC study dashboard.
        </p>
        <Form onSubmit={onSubmit} className="login-form registration-form">
          <div className="invite-code-panel">
            <p className="invite-code-subtitle">
              Access to the study platform requires an invite code.
            </p>
            <InputField
              name="inviteCode"
              label="Invite code"
              error={formErrors.inviteCode}
              fieldRef={inviteCodeField}
            />
          </div>
          <InputField
            name="username"
            label="Username"
            error={formErrors.username}
            fieldRef={usernameField}
          />
          <InputField
            name="email"
            label="Email address"
            error={formErrors.email}
            fieldRef={emailField}
          />
          <InputField
            name="password"
            label="Password"
            type="password"
            error={formErrors.password}
            fieldRef={passwordField}
          />
          <InputField
            name="password2"
            label="Confirm password"
            type="password"
            error={formErrors.password2}
            fieldRef={password2Field}
          />
          <Button variant="primary" type="submit" className="login-button">
            Register
          </Button>
          <div className="login-links">
            <Link to="/login">Back to log in</Link>
          </div>
        </Form>
      </div>
    </Body>
  );
}
